export const EDUCATION_SETTING_HOMESCHOOL = 'Homeschool';

export const EDUCATION_SETTING_OPTIONS = [
  { value: 'In-person public/private', label: 'In-person public/private' },
  { value: EDUCATION_SETTING_HOMESCHOOL, label: EDUCATION_SETTING_HOMESCHOOL },
  { value: 'Remote', label: 'Remote' },
] as const;

export const EDUCATION_EVALUATION_STATUS_OPTIONS = [
  { value: 'EVALUATED', label: 'Evaluated' },
  { value: 'NOT_EVALUATED', label: 'Not evaluated' },
  { value: 'SCHEDULED_EVALUATION', label: 'Scheduled evaluation' },
] as const;

export const IEP_OR_504_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'IEP', label: 'IEP' },
  { value: '504', label: '504' },
] as const;

export const CLASSROOM_SETTING_OPTIONS = [
  { value: 'Speech-Language', label: 'Speech-Language' },
  { value: 'Occupational Therapy', label: 'Occupational Therapy' },
  { value: 'Physical Therapy', label: 'Physical Therapy' },
  { value: 'Social Skill Groups', label: 'Social Skill Groups' },
  { value: 'Applied Behavior Analysis', label: 'Applied Behavior Analysis' },
  { value: '1:1 aide', label: '1:1 aide' },
  { value: 'Additional time', label: 'Additional time' },
  { value: 'General education classroom', label: 'General education classroom' },
  { value: 'Special education classroom', label: 'Special education classroom' },
  {
    value: 'Integrated general education services',
    label: 'Integrated general education services',
  },
  { value: 'Other', label: 'Other' },
] as const;

export const CHILD_ATTITUDE_TOWARDS_SCHOOL_OPTIONS = [
  {
    value: 'Very Positive (Enthusiastic, Excited to Attend)',
    label: 'Very Positive (Enthusiastic, Excited to Attend)',
  },
  { value: 'Positive (Generally Enjoys School)', label: 'Positive (Generally Enjoys School)' },
  { value: 'Somewhat Positive', label: 'Somewhat Positive' },
  { value: 'Neutral (No Strong Feelings)', label: 'Neutral (No Strong Feelings)' },
  { value: 'Mixed (Varies Day-to-Day)', label: 'Mixed (Varies Day-to-Day)' },
  { value: 'Reluctant (Needs Encouragement)', label: 'Reluctant (Needs Encouragement)' },
  { value: 'Somewhat Negative', label: 'Somewhat Negative' },
  { value: 'Negative (Avoidant/Dislikes School)', label: 'Negative (Avoidant/Dislikes School)' },
  {
    value: 'Highly Negative (Refusal, Distress, Tantrums)',
    label: 'Highly Negative (Refusal, Distress, Tantrums)',
  },
  {
    value: 'Anxious (Separation Anxiety, Worry)',
    label: 'Anxious (Separation Anxiety, Worry)',
  },
] as const;

export const EDUCATION_SCHOOL_NAME_MIN_LENGTH = 4;

export const EDUCATION_DESCRIPTION_MIN_LENGTH = 8;

export const EDUCATION_HOURS_PER_WEEK_BOUNDS = {
  min: 0,
  max: 40,
  inputMin: 0.1,
  step: 0.1,
  decimalPlaces: 1,
} as const;

export const EMPTY_EDUCATION_VALUES = {
  education_setting: '',
  number_of_hours_per_week: '',
  school_name: '',
  school_phone_number: '',
  education_description: '',
  focus_area_description: '',
  client_education_evaluation_status: '',
  client_education_evaluation_date: null,
  iep_or_504_in_place: '',
  education_support: '',
  client_classroom_setting: '',
  client_attitude_towards_school: '',
} as const;

export const EDUCATION_DATE_FIELD_NAMES = ['client_education_evaluation_date'] as const;

export const EDUCATION_DESCRIPTION_FIELD_NAMES = [
  'education_description',
  'focus_area_description',
] as const;

export const EDUCATION_FIELD_NAMES = [
  'education_setting',
  'number_of_hours_per_week',
  'school_name',
  'school_phone_number',
  'education_description',
  'focus_area_description',
  'client_education_evaluation_status',
  'client_education_evaluation_date',
  'iep_or_504_in_place',
  'education_support',
  'client_classroom_setting',
  'client_attitude_towards_school',
] as const;
